import Shops from "../symbols/shops";

const initialState = {
  data: [],
  totalCount: null,
  loading: false,
  error: false,
};

export default function ShopsReducer(state = initialState, action: any) {
  switch (action.type) {
    case Shops.GET_SHOPS:
      return { ...state, loading: true, error: false };
    case Shops.GET_SHOPS_SUCCESS:
      if (state.totalCount) {
        let temp: any = state.data;
        temp.forEach((item, index) => {
          action.payload.Result.Data.forEach((x, i) => {
            if (x.Region === item.Region) {
              temp[index].Shops = [...item.Shops, ...x.Shops];
            } else {
              const isExist = temp.find((shop) => shop.Region === x.Region);
              if (!isExist) {
                temp.push(x);
              }
            }
          });
        });
        return {
          ...state,
          data: temp,
          totalCount: action.payload.Result.Count,
          loading: false,
          error: false,
        };
      } else {
        return {
          ...state,
          data: action.payload.Result.Data,
          totalCount: action.payload.Result.Count,
          loading: false,
          error: false,
        };
      }

    case Shops.GET_SHOPS_FAILURE:
      return {
        ...state,
        data: [],
        totalCount: initialState.totalCount,
        loading: false,
        error: true,
      };
    case Shops.CLEAR_GET_SHOPS:
      return {
        ...state,
        data: [],
        totalCount: initialState.totalCount,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
